/**
 * Focuses an element, which need not be one that can take focus by itself (a
 * heading or a landmark, say), and says whether focus got there. A `tabindex`
 * this adds is taken off again when focus leaves. An element that keeps a
 * `tabindex="-1"` takes focus from every click on the text inside it, and the
 * next Tab then starts again from its top (WCAG 2.4.3).
 */
export const focusStatic = (
  element: HTMLElement,
  options?: FocusOptions,
): boolean => {
  const added = !element.hasAttribute('tabindex') && element.tabIndex < 0;
  if (added) {
    element.setAttribute('tabindex', '-1');
  }
  element.focus(options);
  const focused = document.activeElement === element;
  if (added) {
    if (focused) {
      element.addEventListener(
        'blur',
        () => element.removeAttribute('tabindex'),
        {once: true},
      );
    } else {
      element.removeAttribute('tabindex');
    }
  }
  return focused;
};
